require("./dist/inputmask/inputmask.extensions");
require("./dist/inputmask/inputmask.date.extensions");
require("./dist/inputmask/inputmask.numeric.extensions");

module.exports = require("./dist/inputmask/inputmask.js");



//////////////////
// WEBPACK FOOTER
// ./~/inputmask/index.js
// module id = 839
// module chunks = 0